export const listCss = {
    backgroundColor: '#f5f5f5',
    color: 'white',
    marginBottom: '25px',
    marginTop: '25px'
}